<div class="govuk-phase-banner">
  <p class="govuk-phase-banner__content">
    <span class="govuk-phase-banner__text">
      <a [routerLink]="['/contact-us-or-leave-feedback']" (click)="setReturn()">Contact us or leave feedback</a> to help
      us improve the service.
    </span>
  </p>
</div>
